export default __webpack_public_path__ + "static/media/learn_mid_popup_bottom.f0d0bf43.png";